import React from "react";

/* content for main Hero section: */
import HomeHeroIconsDesktopSvg from "./images/home-hero-icons-desktop.svg";
import HomeHeroIconsMobileSvg from "./images/home-hero-icons-mobile.svg";

export const heroTitle = "Icons and Photos For Everything";

export const heroSvgDesktop = HomeHeroIconsDesktopSvg;

export const heroSvgMobile = HomeHeroIconsMobileSvg;

/* content for Collections: */

// Collection Images:
import Covid19 from "./images/covid-19.png";
import SupportForUkraine from "./images/ukraine.png";
import Spring from "./images/spring.svg";
import BabyAnimals from "./images/baby_animals.svg";

import IconSetBrowse from "./images/icon-set-browse.svg";
import IconSetDogs from "./images/icon-set-dogs.svg";
import IconSetFuturisticTechnology from "./images/icon-set-futuristic-technology.svg";
import IconSetIconathonSvg from "./images/icon-set-iconathon.svg";
import IconSetLandmarks from "./images/icon-set-landmarks.svg";

export const collectionsTitle =
    "Noun Project is building a global visual language that unites us.";

export const collections = [
    {
        title: "Iconathon",
        subtitle: "Redefining Women Collection",
        url: "/Iconathon1/collection/redefining-women/",
        imageSrcAndTitle: {
            imageSrc: IconSetIconathonSvg,
            title: "Iconathon"
        },
        type: "darkMode"
    },
    {
        title: "Support for Ukraine",
        subtitle: null,
        url: "https://blog.thenounproject.com/support-for-ukraine/",
        imageSrcAndTitle: {
            imageSrc: SupportForUkraine,
            title: "Support for Ukraine"
        },
        isPhoto: true,
        type: "primary"
    },
    {
        title: "Dogs",
        subtitle: null,
        url: "/an.derevyanko/collection/dogs/",
        imageSrcAndTitle: {
            imageSrc: IconSetDogs,
            title: "Dogs"
        },
        type: "primary"
    },
    {
        title: "COVID-19",
        subtitle: null,
        url: "/browse/term/photos/covid/",
        imageSrcAndTitle: {
            imageSrc: Covid19,
            title: "COVID-19"
        },
        isPhoto: true,
        backgroundSize: "auto 101%",
        type: "primary"
    },
    {
        title: "Futuristic Technology",
        subtitle: null,
        url: "/vinzencestudio/collection/futuristic-technology/",
        imageSrcAndTitle: {
            imageSrc: IconSetFuturisticTechnology,
            title: "Futuristic Technology"
        },
        type: "primary"
    },
    {
        title: "Spring",
        subtitle: null,
        url: "/search/photos/?photospage=1&q=spring",
        imageSrcAndTitle: {
            imageSrc: Spring,
            title: "Spring"
        },
        isPhoto: true,
        backgroundSize: "auto 101%",
        type: "primary"
    },
    {
        title: "World Landmarks",
        subtitle: null,
        url: "/browse/collection-icon/landmark-88066/?p=1",
        imageSrcAndTitle: {
            imageSrc: IconSetLandmarks,
            title: "World Landmarks"
        },
        type: "primary"
    },
    {
        title: "Baby Animals + Easter",
        subtitle: null,
        url: "/search/photos/?photospage=1&q=baby%20animals%20%2B%20easter%20",
        imageSrcAndTitle: {
            imageSrc: BabyAnimals,
            title: "Baby Animals + Easter"
        },
        isPhoto: true,
        type: "primary"
    },

    {
        title: "Browse New Icons",
        subtitle: null,
        url: "/browse/",
        imageSrcAndTitle: {
            imageSrc: IconSetBrowse,
            title: "Browse New Icons"
        },
        type: "primary"
    }
];

/* content for Recent Posts: */
import RecentPostsImg1 from "./images/recent-posts-pantone.png";
import RecentPostsImg2 from "./images/recent-posts-20-top-designers.png";
import RecentPostsImg3 from "./images/recent-posts-ami-vitale.png";

export const recentPostsTitle = "Recent Posts";

export const recentPosts = [
    {
        title: "Celebrating Pantone's Color of the Year",
        category: "Visual Trends",
        imgSrc: RecentPostsImg1,
        url:
            "https://medium.com/noun-project/celebrating-pantones-2022-color-of-the-year-dcf110430602",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "20 Top Designers and Illustrators",
        category: "Spotlight",
        imgSrc: RecentPostsImg2,
        url:
            "https://thelist.thenounproject.com/?utm_source=nphome&utm_medium=post&utm_campaign=the_list&utm_term=fall_2021",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    },
    {
        title: "Ami Vitale",
        category: "Photographer Spotlight",
        imgSrc: RecentPostsImg3,
        url:
            "https://blog.thenounproject.com/behind-the-scenes-with-nat-geo-photographer-and-filmmaker-ami-vitale-9f92be0dc58e?source=friends_link&sk=0154a22bac054ca3ba11f1b10233df1c",
        target: "_blank",
        imageIsLink: true,
        headingIsLink: true,
        subtitleIsLink: true
    }
];

/* Content for Promo section: */
import { PRICING, appsAndPluginsPath, API_LANDING_PAGE } from "data/links";
import Payouts from "core/ReusableIcons/Payouts";
import Computer from "core/ReusableIcons/Computer";
import Api from "core/ReusableIcons/Api";

import AppAppleSvg from "./images/AppAppleSvg";
import AppAdobeSvg from "./images/AppAdobeSvg";
import AppMicrosoftSvg from "./images/AppMicrosoftSvg";
import AppGsuiteSvg from "./images/AppGsuiteSvg";

export const promo = [
    {
        url: PRICING,
        iconName: <Payouts size="xl" title="Pricing &amp; Licenses" />,
        title: "Pricing & Licenses",
        description:
            "All images available as free downloads. Purchase a royalty-free license to support artists and get more options.",
        learnMoreContent: "Learn More"
    },
    {
        url: appsAndPluginsPath,
        iconName: <Computer size="xl" title="Apps &amp; Plugins" />,
        title: "Apps & Plugins",
        description:
            "Drag and drop icons into the software you use. Access vector, png, & pdf from Mac, PowerPoint, Adobe, Google, more.",
        learnMoreContent: [
            {
                icon: <AppAppleSvg title="Apple" />
            },
            {
                icon: <AppAdobeSvg title="Adobe" />
            },
            {
                icon: <AppMicrosoftSvg title="Microsoft" />
            },
            {
                icon: <AppGsuiteSvg title="GSuite" />
            }
        ]
    },
    {
        url: API_LANDING_PAGE,
        iconName: <Api size="xl" title="API" />,
        title: "API",
        description:
            "Access the entire icon collection via our REST API. Reliably supports growth stage to enterprise clients. ",
        learnMoreContent: "Learn More"
    }
];
